<template>
  <div>
    <v-card style="margin-bottom: 40px" class="pt-1 mt-4">
      <v-toolbar flat dense>
        <v-toolbar-title class="text-subtitle-1">SOLICITUDES</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <v-btn
          small
          color="primary"
          class="mr-2"
          v-if="permisos && permisos.includes('FUN_CREAR_SOLICITUD_RETENCION')"
          @click="openCrearRetencion"
        >
          Crear retención
        </v-btn>
        <v-tooltip v-if="!telefonoBlocked" left>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              color="error darken-1"
              v-on="on"
              class="mr-2"
              :loading="loadingListaNegra"
              @click="showConfirmacionListaNegra = true"
            >
              <v-icon small>mdi-lock</v-icon>
            </v-btn>
          </template>
          <span>Bloquear teléfono para redenciones</span>
        </v-tooltip>

        <v-btn
          small
          color="primary"
          class="mr-2"
          v-if="permisos && permisos.includes('FUN_CREAR_SOLICITUD_REDENCION')"
          @click="openCrearRedencion"
        >
          Crear redencion
        </v-btn>

        <v-btn
          small
          color="primary"
          v-if="permisos && permisos.includes('FUN_CREAR_SOLICITUD_REDENCION')"
          @click="openCrearSolicitud"
        >
          Crear Solicitud
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-data-table
        :headers="columns"
        :items="solicitudes"
        item-key="name"
        class="elevation-1"
        :loading="loading"
        loading-text="Cargando..."
        no-data-text="Sin solicitudes"
        dense
      >
        <template v-slot:item.accion="{ item }">
          <v-icon
            v-if="permisos && permisos.includes('FUN_REGISTRO_DE_LA_SOLICITUD')"
            small
            class="mr-2"
            @click="goToSolicitud(item)"
          >
            mdi-eye
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <solicitudDialogForm
      v-if="showCreacion"
      :show="showCreacion"
      :emision="emision"
      route="/v1/solicitud/manual"
      @close="showCreacion = false"
    ></solicitudDialogForm>

    <CrearRedencion
      :solicitud="solicitudSelected"
      lockedHasEmision="Redención Normal"
      :show="showModal"
      @close="handleCloseRedencion"
      :mode="modeRedencion"
      :ignoreClientStep="true"
    />

    <CrearRetencion
      :solicitud="solicitudSelected"
      :show="showModalRetencion"
      :emisionId="emisionId"
      @close="handleCloseRetencion"
      :mode="modeRetencion"
      :ignoreClientStep="true"
    />

    <CrearSolicitud
      :solicitud="solicitudSelected"
      :show="showModalSolicitud"
      @close="handleCloseSolicitud"
      :mode="modeSolicitud"
      :ignoreClientStep="true"
    />

    <confirmacionListaNegra
      v-if="showConfirmacionListaNegra"
      :show="showConfirmacionListaNegra"
      @confirm="addToListaNegra"
      @close="showConfirmacionListaNegra = false"
    />
  </div>
</template>

<script>
import solicitudDialogForm from "@/components/solicitudes/solicitudDialogForm.vue";
import { getSolicitudesByIdEmision } from "@/services/solicitudService";
import { mapState } from "vuex";
import { addTelefonoToListaNegra } from "@/services/listaNegraService.js";

import CrearRedencion from "@/components/solicitudes/modals/CrearRedencion.vue";
import CrearRetencion from "@/components/solicitudes/modals/CrearRetencion.vue";
import CrearSolicitud from "@/components/solicitudes/modals/CrearSolicitud.vue";

export default {
  name: "Solicitudes",

  components: {
    solicitudDialogForm,
    CrearRedencion,
    CrearRetencion,
    CrearSolicitud,
    confirmacionListaNegra: () => import("./confirmacionListaNegra.vue"),
  },

  props: {
    emisionId: {
      type: Number,
      required: true,
    },
    emision: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
      showCreacion: false,
      solicitudes: [],
      columns: [
        { text: "Título", sortable: false, value: "titulo" },
        { text: "Tipo", sortable: false, value: "tipo" },
        { text: "Ver", sortable: false, value: "accion" },
      ],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      showConfirmacionListaNegra: false,
      loadingListaNegra: false,
      telefonoBlocked: false,
      showModal: false,
      showModalRetencion: false,
      showModalSolicitud: false,
      solicitudSelected: null,
      modeRedencion: "create",
      modeRetencion: "create",
      modeSolicitud: "create",
    };
  },

  computed: {
    ...mapState("permisos", ["permisos"]),
  },

  mounted() {
    this.loadSolicitudes();
  },

  methods: {
    async loadSolicitudes() {
      this.loading = true;
      const response = await getSolicitudesByIdEmision(this.emisionId);
      this.solicitudes = response.solicitudes;
      this.loading = false;
    },
    openCrearRetencion() {
      this.solicitudSelected = this.emision;
      this.modeRetencion = "create";
      this.showModalRetencion = true;
    },

    openCrearRedencion() {
      this.solicitudSelected = this.emision;
      this.modeRedencion = "create";
      this.showModal = true;
    },

    openCrearSolicitud() {
      this.solicitudSelected = this.emision;
      this.modeSolicitud = "create";
      this.showModalSolicitud = true;
    },

    goToSolicitud(solicitud) {
      if (
        solicitud.tipo == "Redención Beneficio" ||
        solicitud.tipo == "Redención Asistencia"
      ) {
        this.solicitudSelected = solicitud;
        this.modeRedencion = "view";
        this.showModal = true;
      } else if(solicitud.tipo == "Retención") {
        this.solicitudSelected = solicitud;
        this.modeRetencion = "view";
        this.showModalRetencion = true;
      } else {
        console.log("solicitud", solicitud);
        this.solicitudSelected = solicitud;
        this.modeSolicitud = "view";
        this.showModalSolicitud = true;
      }
    },

    handleCloseRedencion() {
      this.showModal = false;
      this.solicitudSelected = null;
      this.modeRedencion = "create";
    },

    handleCloseRetencion() {
      this.showModalRetencion = false;
      this.solicitudSelected = null;
      this.modeRetencion = "create";
    },

    handleCloseSolicitud() {
      this.showModalSolicitud = false;
      this.solicitudSelected = null;
      this.modeSolicitud = "create";
    },

    async addToListaNegra(telefono) {
      this.loadingListaNegra = true;
      this.showConfirmacionListaNegra = false;

      try {
        await addTelefonoToListaNegra({
          telefono: telefono,
          emisionId: this.emision.id,
          origen: "Portal",
        });
        this.telefonoBlocked = true;
        this.$toast.success("Teléfono bloqueado exitosamente");
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.loadingListaNegra = false;
      }
    },
  },
};
</script>
